import { useTranslate } from '@tolgee/react';
import { useMemoizedFn } from 'ahooks';
import { Checkbox, Input, Space } from 'antd';
import Empty from 'components/Empty';
import { debounce } from 'lodash-es';
import { useMemo, useState } from 'react';
import { AssistantFromSameDeptData } from 'services/api/admin';
import {
  useCategoryAwareFilterAdvance,
  useSetCategoryAwareFilterAdvance,
} from 'hooks/business/conversationsHooks/useCategoryFilterState';
import { ConversationCategoryType } from 'hooks/business/conversationsHooks/useConversationCategory';

interface FilterAssistantProps {
  category: ConversationCategoryType;
  assistantList: AssistantFromSameDeptData[];
  onChange: () => void;
}

export const FilterAssistant = (props: FilterAssistantProps) => {
  const { category, assistantList, onChange } = props;
  const { t } = useTranslate();
  const filterAdvance = useCategoryAwareFilterAdvance(category);
  const setConversationFilterAdvance = useSetCategoryAwareFilterAdvance();
  const [keyword, setKeyword] = useState('');

  const handleChange = useMemoizedFn(
    debounce((value) => {
      setConversationFilterAdvance(category, {
        assistantFilters: value,
      });
      onChange();
    }, 500),
  );

  const handleChangeKeyword = useMemoizedFn((e) => {
    setKeyword(e.target.value);
  });

  const filterAssistantList = useMemo(() => {
    if (!keyword) {
      return assistantList;
    }
    return assistantList.filter((value) => value.name.includes(keyword));
  }, [assistantList, keyword]);

  return (
    <div className="h-60 py-3 px-4 flex flex-col gap-2">
      <Input
        size="small"
        placeholder={t('form.inputPlaceholder')}
        value={keyword}
        onChange={handleChangeKeyword}
      />
      <Checkbox.Group
        className="flex-1 overflow-y-auto"
        value={filterAdvance?.assistantFilters}
        onChange={handleChange}
      >
        <Space direction="vertical">
          {filterAssistantList.length === 0 && <Empty className="!ml-12 !mt-3" />}
          {filterAssistantList.map((value) => (
            <Checkbox value={`${value.id}`}>{value.name}</Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
};
